import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { PriceDisplay } from 'dibs-buyer-price';
import { FormattedMessage } from 'dibs-react-intl';
import { PdpSharedAuctionViewHistory } from '../PdpSharedAuctionViewHistory/PdpSharedAuctionViewHistory';

// types
import { PdpSharedAuctionClosed_item$key as Item } from './__generated__/PdpSharedAuctionClosed_item.graphql';

// styles
import styles from './PdpSharedAuctionClosed.scss';

type Props = {
    item: Item;
    currency: string;
    linkToBidHistory?: boolean;
};

const copy = {
    biddingClosed: (
        <FormattedMessage
            id="PdpSharedAuctionClosed.biddingClosed"
            defaultMessage="Bidding Closed"
        />
    ),
};

const itemFragment = graphql`
    fragment PdpSharedAuctionClosed_item on Item {
        serviceId
        ...useAuctionState_item @arguments(page: pdp)
        ...useAuctionSecondChanceInfo_item @arguments(page: pdp)
        ...PriceDisplay_item
            @arguments(
                userId: $userId
                isTrade: $isTrade
                userCountryCode: $userCountryCode
                priceBookName: $priceBookName
            )
    }
`;

export const PdpSharedAuctionClosed: FC<Props> = ({
    item: itemRef,
    currency,
    linkToBidHistory,
}) => {
    const item = useFragment(itemFragment, itemRef);

    return (
        <div className={styles.container}>
            <span className={styles.closed} data-tn="pdp-bidding-closed">
                {copy.biddingClosed}
            </span>
            <span className={styles.price}>
                <PriceDisplay currency={currency} item={item} useSvgIcon />
            </span>
            {linkToBidHistory && (
                <PdpSharedAuctionViewHistory itemId={item.serviceId} currency={currency} />
            )}
        </div>
    );
};
